module.exports = __webpack_public_path__ + "img/quickcash.023d7736.png";